import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { CityDetailModel } from '../models/cityData';
import atlas from './atlas';
import { getSessionStorage } from '@/lib/service/storage';
var m = {
  namespaced: true,
  // @ts-ignore
  state: {
    infoMap: {},
    cityListMap: {},
    cityDetailMap: {},
    landmarkDetailMap: {},
    landmarkMap: {},
    messageList: {
      list: [],
      loaded: false,
      requesting: false
    },
    participationList: {},
    energy: 0,
    landmarkRank: {
      list: [],
      loaded: false,
      requesting: false,
      self: null
    },
    jigsawRank: {
      list: [],
      loaded: false,
      requesting: false,
      self: null
    },
    touringRank: {
      list: [],
      loaded: false,
      requesting: false,
      self: null
    },
    isNew: false,
    finishCount: {},
    missions: [],
    history: {
      list: [],
      loaded: false,
      req: false
    },
    medalCard: '',
    specialActive: null,
    specialTeam: {
      list: [],
      loaded: false,
      req: false
    },
    specialOption: null,
    inviteInfoMap: {},
    currentCityID: 0,
    cityMapFinishData: {},
    imgloadMap: {},
    noticeSwitch: {
      go_notice: true,
      visit_notice: true
    }
  },
  modules: {
    atlas: atlas,
    tipsAlert: {},
    expire: {},
    rollMsg: {}
  },
  mutations: {
    setInfoMap: function setInfoMap(state, _a) {
      var activityId = _a.activityId,
          info = _a.info;
      Vue.set(state.infoMap, activityId, info);
    },
    setCityListMap: function setCityListMap(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      Vue.set(state.cityListMap, activityId, list);
    },
    setDreamIsNew: function setDreamIsNew(state, _a) {
      var is_new = _a.is_new;
      state.isNew = is_new;
    },
    setCityDetailMap: function setCityDetailMap(state, _a) {
      var cityId = _a.cityId,
          detail = _a.detail;
      Vue.set(state.cityDetailMap, cityId, detail);
      detail.landmarks.forEach(function (ele) {
        Vue.set(state.landmarkMap, ele.id, ele);
      });
    },
    setLandmarkDetailMap: function setLandmarkDetailMap(state, _a) {
      var landmarkId = _a.landmarkId,
          detail = _a.detail;
      Vue.set(state.landmarkDetailMap, landmarkId, detail);
    },

    /**
     * 消息列表
     */
    concatMessageList: function concatMessageList(state, _a) {
      var list = _a.list;
      state.messageList.list = state.messageList.list.concat(list);
    },
    setMessageListLoaded: function setMessageListLoaded(state, _a) {
      var loaded = _a.loaded;
      state.messageList.loaded = loaded;
    },
    setMessageListReq: function setMessageListReq(state, _a) {
      var req = _a.req;
      state.messageList.requesting = req;
    },

    /*
    * 消息列表
    */
    initParticipationList: function initParticipationList(state, activityId) {
      Vue.set(state.participationList, activityId, {
        list: [],
        requesting: false,
        loaded: false
      });
    },
    concatParticipationList: function concatParticipationList(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      state.participationList[activityId].list = state.participationList[activityId].list.concat(list);
    },
    setParticipationListLoaded: function setParticipationListLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.participationList[activityId].loaded = loaded;
    },
    setParticipationListReq: function setParticipationListReq(state, _a) {
      var activityId = _a.activityId,
          req = _a.req;
      state.participationList[activityId].requesting = req;
    },
    setEnergy: function setEnergy(state, energy) {
      state.energy = Number(energy);
    },

    /**
     * 地标排行
     */
    concatLandmarkRank: function concatLandmarkRank(state, _a) {
      var list = _a.list;
      state.landmarkRank.list = state.landmarkRank.list.concat(list);
    },
    setLandmarkRankSelf: function setLandmarkRankSelf(state, _a) {
      var self = _a.self;
      state.landmarkRank.self = self;
    },
    setLandmarkRankLoaded: function setLandmarkRankLoaded(state, _a) {
      var loaded = _a.loaded;
      state.landmarkRank.loaded = loaded;
    },
    setLandmarkRankReq: function setLandmarkRankReq(state, _a) {
      var req = _a.req;
      state.landmarkRank.requesting = req;
    },

    /**
     * 拼图排行
     */
    concatJigsawRank: function concatJigsawRank(state, _a) {
      var list = _a.list;
      state.jigsawRank.list = state.jigsawRank.list.concat(list);
    },
    setJigsawRankSelf: function setJigsawRankSelf(state, _a) {
      var self = _a.self;
      state.jigsawRank.self = self;
    },
    setJigsawRankLoaded: function setJigsawRankLoaded(state, _a) {
      var loaded = _a.loaded;
      state.jigsawRank.loaded = loaded;
    },
    setJigsawRankReq: function setJigsawRankReq(state, _a) {
      var req = _a.req;
      state.jigsawRank.requesting = req;
    },
    setFinishCount: function setFinishCount(state, finishCount) {
      state.finishCount = finishCount;
    },

    /**
     * 房车排行
     */
    concatTouringRank: function concatTouringRank(state, _a) {
      var list = _a.list;
      state.touringRank.list = state.touringRank.list.concat(list);
    },
    setTouringRankSelf: function setTouringRankSelf(state, _a) {
      var self = _a.self;
      state.touringRank.self = self;
    },
    setTouringRankLoaded: function setTouringRankLoaded(state, _a) {
      var loaded = _a.loaded;
      state.touringRank.loaded = loaded;
    },
    setTouringRankReq: function setTouringRankReq(state, _a) {
      var req = _a.req;
      state.touringRank.requesting = req;
    },

    /** 历史记录相关 */
    concatHistory: function concatHistory(state, _a) {
      var list = _a.list;
      state.history.list = state.history.list.concat(list);
    },
    setHistoryLoaded: function setHistoryLoaded(state, _a) {
      var loaded = _a.loaded;
      state.history.loaded = loaded;
    },
    setHistoryReq: function setHistoryReq(state, _a) {
      var req = _a.req;
      state.history.req = req;
    },
    setMissions: function setMissions(state, data) {
      state.missions = data;
    },
    setTipsAlert: function setTipsAlert(state, data) {
      state.tipsAlert = data;
    },
    setExpire: function setExpire(state, expire) {
      state.expire = expire;
    },
    setRollMsg: function setRollMsg(state, rollMsg) {
      state.rollMsg = rollMsg;
    },
    setMedalCard: function setMedalCard(state, medalCard) {
      state.medalCard = medalCard;
    },
    setSpecialActivitySet: function setSpecialActivitySet(state, specialActive) {
      state.specialActive = specialActive;
    },
    setspecialTeam: function setspecialTeam(state, _a) {
      var list = _a.list;
      state.specialTeam.list = state.specialTeam.list.concat(list);
    },
    specialTeamReq: function specialTeamReq(state, req) {
      state.specialTeam.req = req;
    },
    specialTeamLoaded: function specialTeamLoaded(state, loaded) {
      state.specialTeam.loaded = loaded;
    },
    setSpecialOption: function setSpecialOption(state, option) {
      state.specialOption = option;
    },
    setCurrentCity: function setCurrentCity(state, currentCityID) {
      state.currentCityID = currentCityID;
    },
    setInviteInfo: function setInviteInfo(state, _a) {
      var activityId = _a.activityId,
          info = _a.info;
      Vue.set(state.inviteInfoMap, activityId, info);
    },
    setCityMapFinishData: function setCityMapFinishData(state, _a) {
      var data = _a.data,
          id = _a.id;
      Vue.set(state.cityMapFinishData, id, data);
    },
    setImgloadMap: function setImgloadMap(state, _a) {
      var key = _a.key,
          map = _a.map;
      Vue.set(state.imgloadMap, key, map);
    },
    setNoticeSwitch: function setNoticeSwitch(state, data) {
      if (data) {
        state.noticeSwitch = data;
      }
    }
  },
  actions: {
    /**
     * 获取信息
     */
    getInfo: function getInfo(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/info', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setInfoMap', {
                  activityId: activityId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取城市列表
     */
    getCityList: function getCityList(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/city/list', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCityListMap', {
                  activityId: activityId,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 是否是新人
     */
    getDreamIsNew: function getDreamIsNew(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/is_new', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setDreamIsNew', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 大地图进度条
     */
    getFinishCount: function getFinishCount(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/finish_count', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setFinishCount', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提示弹窗
     */
    getTipsAlert: function getTipsAlert(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/tips_alert', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTipsAlert', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 过期弹窗
     */
    getExpire: function getExpire(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var date, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              date = getSessionStorage('isReq') || 0;

              if (+new Date() - +date < 86400000) {
                context.commit('setExpire', undefined);
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/get_expire', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setExpire', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 滚动提示
     */
    getRollMsg: function getRollMsg(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/roll_msg', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setRollMsg', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 重置大地图
     */
    resetMap: function resetMap(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/reset', {
                activity_id: activityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 补玩重置
     */
    resetCity: function resetCity(context, _a) {
      var cityId = _a.cityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/reset_city', {
                city_id: cityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取城市详情
     */
    getCityDetail: function getCityDetail(context, _a) {
      var cityId = _a.cityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/city/detail', {
                params: {
                  city_id: cityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCityDetailMap', {
                  cityId: cityId,
                  detail: new CityDetailModel(rdata.data)
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取地标详情
     */
    getLandmarkDetail: function getLandmarkDetail(context, _a) {
      var landmarkId = _a.landmarkId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/landmark/detail', {
                params: {
                  landmark_id: landmarkId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setLandmarkDetailMap', {
                  landmarkId: landmarkId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取通知
     */
    getMessage: function getMessage(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.messageList;

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.list = [];
                wrap.loaded = false;
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setMessageListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/message', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatMessageList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setMessageListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setMessageListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取报名列表
     */
    getParticipation: function getParticipation(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.participationList[activityId];

              if (!wrap) {
                commit('initParticipationList', activityId);
                wrap = state.participationList[activityId];
              }

              if (wrap.requesting || wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.list = [];
                wrap.loaded = false;
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setParticipationListReq', {
                activityId: activityId,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/participation_list', {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatParticipationList', {
                  activityId: activityId,
                  list: list
                });

                if (list.length < count) {
                  commit('setParticipationListLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }
              }

              commit('setParticipationListReq', {
                activityId: activityId,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取能量
     */
    getEnergy: function getEnergy(context) {
      var _a;

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/energy')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setEnergy', ((_a = rdata.data) === null || _a === void 0 ? void 0 : _a.energy) || 0);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 前进
     */
    go: function go(context, _a) {
      var activityId = _a.activityId,
          cityId = _a.cityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/go', {
                activity_id: activityId,
                city_id: cityId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 设置目标
     */
    setTarget: function setTarget(context, _a) {
      var activityId = _a.activityId,
          target = _a.target;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/target', {
                activity_id: activityId,
                target: target
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取地标排行
     */
    getLandmarkRank: function getLandmarkRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          _d = _c.offset,
          offset = _d === void 0 ? 0 : _d,
          _e = _c.count,
          count = _e === void 0 ? 15 : _e,
          _f = _c.type,
          type = _f === void 0 ? '' : _f,
          _g = _c.specialId,
          specialId = _g === void 0 ? '' : _g,
          _h = _c.forceUpdate,
          forceUpdate = _h === void 0 ? false : _h;

      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_j) {
          switch (_j.label) {
            case 0:
              wrap = state.landmarkRank;

              if (offset === 0 && forceUpdate) {
                wrap.list = [];
                wrap.loaded = wrap.requesting = false;
                wrap.self = null;
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              commit('setLandmarkRankReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/landmark_rank', {
                params: {
                  offset: offset,
                  count: count,
                  type: type,
                  special_id: specialId
                }
              })];

            case 1:
              response = _j.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatLandmarkRank', {
                  list: data.rank || []
                });
                commit('setLandmarkRankSelf', {
                  self: data.self || null
                });

                if ((data.rank || []).length < count) {
                  commit('setLandmarkRankLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setLandmarkRankReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取拼图排行
     */
    getJigsawRank: function getJigsawRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          _d = _c.offset,
          offset = _d === void 0 ? 0 : _d,
          _e = _c.count,
          count = _e === void 0 ? 15 : _e,
          _f = _c.type,
          type = _f === void 0 ? '' : _f,
          _g = _c.specialId,
          specialId = _g === void 0 ? '' : _g,
          _h = _c.forceUpdate,
          forceUpdate = _h === void 0 ? false : _h;

      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_j) {
          switch (_j.label) {
            case 0:
              wrap = state.jigsawRank;

              if (offset === 0 && forceUpdate) {
                wrap.list = [];
                wrap.loaded = wrap.requesting = false;
                wrap.self = null;
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              commit('setJigsawRankReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/jigsaw_rank', {
                params: {
                  offset: offset,
                  count: count,
                  type: type,
                  special_id: specialId
                }
              })];

            case 1:
              response = _j.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatJigsawRank', {
                  list: data.rank || []
                });
                commit('setJigsawRankSelf', {
                  self: data.self || null
                });

                if ((data.rank || []).length < count) {
                  commit('setJigsawRankLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setJigsawRankReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取房车排行
     */
    getTouringRank: function getTouringRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          _d = _c.offset,
          offset = _d === void 0 ? 0 : _d,
          _e = _c.count,
          count = _e === void 0 ? 15 : _e,
          _f = _c.type,
          type = _f === void 0 ? '' : _f,
          _g = _c.specialId,
          specialId = _g === void 0 ? '' : _g,
          _h = _c.forceUpdate,
          forceUpdate = _h === void 0 ? false : _h;

      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, data;
        return __generator(this, function (_j) {
          switch (_j.label) {
            case 0:
              wrap = state.touringRank;

              if (offset === 0 && forceUpdate) {
                wrap.list = [];
                wrap.loaded = wrap.requesting = false;
                wrap.self = null;
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              commit('setTouringRankReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/touring_rank', {
                params: {
                  offset: offset,
                  count: count,
                  type: type,
                  special_id: specialId
                }
              })];

            case 1:
              response = _j.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('concatTouringRank', {
                  list: data.rank || []
                });
                commit('setTouringRankSelf', {
                  self: data.self || null
                });

                if ((data.rank || []).length < count) {
                  commit('setTouringRankLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setTouringRankReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取每日任务弹窗内容
     */
    getMissions: function getMissions(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/mission')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMissions', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 领取每日任务奖励
     */
    getFragment: function getFragment(context, type) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/receive', {
                type: type
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取地标卡
     */
    getLandmarkCard: function getLandmarkCard(context, landmark_id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/landmark_card', {
                params: {
                  landmark_id: landmark_id
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /*
     * 获取历史记录
     */
    getHistory: function getHistory(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          activity_id = _b.activity_id,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.history;

              if (forceUpdate && offset === 0) {
                wrap.list = [];
                wrap.loaded = wrap.req = false;
              }

              if (wrap.req || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              commit('setHistoryReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/history', {
                params: {
                  offset: offset,
                  count: count,
                  activity_id: activity_id
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data || [];
                commit('concatHistory', {
                  list: list
                });

                if (list.length < count) {
                  commit('setHistoryLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setHistoryReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取城市完成卡
     */
    getFinishCityCard: function getFinishCityCard(context, cityId) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/finish_city_card', {
                params: {
                  city_id: cityId
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /*
     * 获取路线详情
     * 图鉴id
     */
    getRouteDetail: function getRouteDetail(context, id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/city_detail', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCityDetail', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /*
     * 获取奖牌卡
     */
    getMedalCard: function getMedalCard(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/medal_card', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMedalCard', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /*
     * 获取从首页进入
     */
    addHomeLog: function addHomeLog(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/add_home_log')];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /* * 获取每日单次打卡5公里奖励碎片弹窗
     * 图鉴id
     */
    getFinishDistanceTips: function getFinishDistanceTips(context, activity_id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/finish_distance_tips', {
                params: {
                  activity_id: activity_id
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /* * 专题活动页面图片设置
     */
    getSpecialActivitySet: function getSpecialActivitySet(context, _a) {
      var activity_id = _a.activity_id,
          special_id = _a.special_id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/special_activity_set', {
                params: {
                  activity_id: activity_id,
                  special_id: special_id
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setSpecialActivitySet', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /* * 专题队伍列表
     */
    getSpecialTeamList: function getSpecialTeamList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activity_id = _b.activity_id,
          specialId = _b.specialId,
          offset = _b.offset,
          count = _b.count,
          search = _b.search,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.specialTeam;

              if (forceUpdate && offset === 0) {
                wrap.list = [];
                wrap.req = false;
                wrap.loaded = false;
              }

              wrap = state.specialTeam;

              if (wrap.loaded || wrap.req) {
                return [2
                /*return*/
                ];
              }

              commit('specialTeamReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/special_team_list', {
                params: {
                  activity_id: activity_id,
                  offset: offset,
                  count: count,
                  search: search,
                  special_id: specialId
                }
              })];

            case 1:
              response = _c.sent();
              commit('specialTeamReq', false);
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('setspecialTeam', {
                  list: list
                });

                if (list.length < count) {
                  commit('specialTeamLoaded', true);
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getCurrentCity: function getCurrentCity(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/get_current_city', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setCurrentCity', rdata.data.id);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 获取城市地图成功弹窗数据 */
    getCityMapFinishData: function getCityMapFinishData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var cityId = _b.cityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.cityMapFinishData[cityId]) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/get_finish_share', {
                params: {
                  city_id: cityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCityMapFinishData', {
                  data: rdata.data,
                  id: cityId
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 获取补偿弹窗内容 */
    getCompensate: function getCompensate(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/get_compensate')];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 首次点击地标后调用 */
    changeIsNew: function changeIsNew(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/change_is_new')];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请活动信息
     */
    getInviteInfo: function getInviteInfo(context, _a) {
      var activityId = _a.activityId,
          specialId = _a.specialId,
          _b = _a.forceUpdate,
          forceUpdate = _b === void 0 ? false : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!forceUpdate && context.state.inviteInfoMap[activityId]) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.inviteInfoMap[activityId]
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/invite/info', {
                params: {
                  activity_id: activityId,
                  special_id: specialId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setInviteInfo', {
                  activityId: activityId,
                  info: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取消息开关
     */
    getNoticeSwitch: function getNoticeSwitch(context, _a) {
      var _b = _a.forceUpdate,
          forceUpdate = _b === void 0 ? false : _b;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: context.state.noticeSwitch
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/notice_switch')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setNoticeSwitch', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 开启/关闭消息
     */
    setNoticeSwitch: function setNoticeSwitch(context, _a) {
      var key = _a.key,
          value = _a.value;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;

        var _b;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/notice_status', (_b = {}, _b[key] = value, _b))];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取icl详情
     * Todo：该接口跟活动详情返回的icl_image一致但需要用该接口来记录访问人数
     */
    getIcl: function getIcl(context, activity_id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/dream/get_icl', {
                params: {
                  activity_id: activity_id
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 保存icl-10秒后浏览数
     */
    addIclPv: function addIclPv(context, activity_id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/dream/add_icl_pv', {
                activity_id: activity_id
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;